import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { HolidayAndWayOfWorkingListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 休日・働き方の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 休日・働き方の初期配列
 */
export const createInitialHolidayAndWayOfWorkingList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const idList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: HolidayAndWayOfWorkingListType[] = [
    {
      id: OP_SEARCH_ITEMS.fiveDayWorkweekSystem.id,
      name: OP_SEARCH_ITEMS.fiveDayWorkweekSystem.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.fiveDayWorkweekSystem.id
      ),
      value:
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.FIVE_DAY_WORK_WEEK_SYSTEM
          .code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.FIVE_DAY_WORK_WEEK_SYSTEM.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.MoreThan120DaysOffAYear.id,
      name: OP_SEARCH_ITEMS.MoreThan120DaysOffAYear.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.MoreThan120DaysOffAYear.id
      ),
      value:
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.MORE_THAN_120_DAYS_OFF_A_YEAR
          .code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.MORE_THAN_120_DAYS_OFF_A_YEAR
          .code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.holiday.id,
      name: OP_SEARCH_ITEMS.holiday.name,
      isChecked: idList.some((query) => query === OP_SEARCH_ITEMS.holiday.id),
      value: HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.HOLIDAY.code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.HOLIDAY.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.consecutiveVacations.id,
      name: OP_SEARCH_ITEMS.consecutiveVacations.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.consecutiveVacations.id
      ),
      value:
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.CONSECUTIVE_VACATIONS.code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.CONSECUTIVE_VACATIONS.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.noOvertime.id,
      name: OP_SEARCH_ITEMS.noOvertime.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.noOvertime.id
      ),
      value: HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.NO_OVERTIME.code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.NO_OVERTIME.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.littleOvertime.id,
      name: OP_SEARCH_ITEMS.littleOvertime.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.littleOvertime.id
      ),
      value: HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.LITTLE_OVER_TIME.code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.LITTLE_OVER_TIME.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.flexibleWork.id,
      name: OP_SEARCH_ITEMS.flexibleWork.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.flexibleWork.id
      ),
      value: HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.FLEXIBLE_WORK.code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.FLEXIBLE_WORK.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.maternityAndChildcareLeave.id,
      name: OP_SEARCH_ITEMS.maternityAndChildcareLeave.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.maternityAndChildcareLeave.id
      ),
      value:
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.MATERNITY_AND_CHILDCARE_LEAVE
          .code,
      jobCount: findJobCount(
        jobCountData.holidayAndWayOfWorkingList,
        HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY.MATERNITY_AND_CHILDCARE_LEAVE
          .code
      ),
    },
  ];

  return initialData;
};
